import styled from "styled-components";

export const DivCointainer = styled.div`
  position: absolute;
  width: 500px;
  height: auto;
  background-color: #ffffff;
  overflow-y: scroll;
  padding-bottom: 0px;
`;

const menuWidth = "500px";
export const MenuWrapper = styled.div`
  background-color: #ffffff;
  display: flex;
  flex: 1;
  z-index: 300;
  height: 100%;
  position: absolute;
  right: 0;
  box-sizing: border-box;
  overflow: hidden;
  max-width: ${menuWidth};
`;

export const Menu = styled.div`
  min-width: ${menuWidth};
  order: ${props => props.order};
`;

export const DivHeaderActions = styled.div`
  display: flex;
  flex: 1 auto;
  cursor: move;
  flex-direction: row;
  justify-content: flex-end;
  background-color: #173f4f;
`;



// WEBPACK FOOTER //
// ./src/editor/layout/editor/styled.js